/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasGestioneFirmatari
 * @restrict E
 * @description Componente che gestisce il secondo sotto-step "Gestione Firmatari" dello step "Richiesta fido"
 */
(function() {
  'use strict';
  var CreasGestioneFirmatariCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.messaggiFctr = messaggiFctr;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    this.selezioneFirmaElettronica = false;
    this.aderitoFirmaElettronica = false;
    this.fieldConfiguration;
    this.showSecondLevelKey = false;
    // Workaround per bug widget fea
    this.anagraficaFea = angular.copy(this.dettPraticaSrvc.datiPratica.intestatario);
    this.anagraficaFea.naturaGiuridica = this.anagraficaFea.formaCostitutiva;
    
    // Spinner
    this.spinner = dettPraticaSrvc.spinner;

    var self = this;

    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
    dettPraticaSrvc.isCancelEnabled = function() {
      return true;
    };

    dettPraticaSrvc.isPrevEnabled = function() {
      return true;
    };

    dettPraticaSrvc.isNextEnabled = function() {
      return true;
    };
    
    dettPraticaSrvc.nextStep = function() {
        self.spinner.pratica = true;
        $q
          .all({nextStep: dettPraticaSrvc.promiseCambiaStep('/passaValutazione')})
          .then(
            function(response) {
              if (self.messaggiFctr.processaResponse(response.nextStep)) {
                return;
              }
              
              dettPraticaSrvc.datiPratica = response.nextStep.data.result;
              dettPraticaSrvc.generaTabs();
            },
            function(reason) {
              self.messaggiFctr.processaResponse(reason.nextStep);
            }
          )
          .finally(function() {
            self.spinner.pratica = false;
          });
      };
      
      this.promiseFieldConfigurator = function() {
    	  
    	  return self.$http({
    	        method: 'GET',
    	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.FIELDCONFIGURATOR
    	  });
    	  
      }
      
      // Recupero la configurazione dei campi
      this.loadFieldConfiguration = function() {
          $q
            .all({fldConfig: self.promiseFieldConfigurator()})
            .then(
              function(response) {
                if (self.messaggiFctr.processaResponse(response.fldConfig)) {
                  return;
                }
                
                self.fieldConfiguration = response.fldConfig.data.result;
              },
              function(reason) {
                self.messaggiFctr.processaResponse(reason.fldConfig);
              }
            );
      }
      
      if (!self.fieldConfiguration) {
    	  self.loadFieldConfiguration();
      }
      
  };

  CreasGestioneFirmatariCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasRichiestaFido/creasGestioneFirmatari/creasGestioneFirmatari.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasGestioneFirmatariComponent = {
    bindings: {},
    controller: CreasGestioneFirmatariCtrl,
    controllerAs: 'creasGestioneFirmatariCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasGestioneFirmatari', CreasGestioneFirmatariComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasRichiestaFido/creasGestioneFirmatari/creasGestioneFirmatari.cmpt.js
// module id = 20
// module chunks = 0 1